namespace $ {

	export type $shm_hitalama_components_versions_snapshot_module = {
		fqn: string
		title: string
		description: string
		repository: string
		dependencies: { fqn: string, link: string }[]
		format: 'ts' | 'js'
		tree: string
		logic: string
		style: string
		default: string
		demo: string
		readme: string
	}

	export type $shm_hitalama_components_versions_snapshot_data = {
		format: 1
		root: string
		modules: $shm_hitalama_components_versions_snapshot_module[]
	}

	/** Read-only compatibility for historical payloads. New releases use GitHub commits. */
	export class $shm_hitalama_components_versions_snapshot extends $giper_baza_entity.with({
		Manifest: $giper_baza_atom_dict,
		Chunks: $giper_baza_dict_to( $giper_baza_atom_text ),
	}) {

		static validate( text: string ) {
			const value = JSON.parse( text ) as $shm_hitalama_components_versions_snapshot_data
			if( value.format !== 1 || !Array.isArray( value.modules ) || !value.modules.some( item => item.fqn === value.root ) ) {
				throw new Error( 'Некорректный снимок приложения.' )
			}
			return value
		}

		@ $mol_mem
		text() {
			this.$.$shm_hitalama_map_component_ready.read( this )
			const manifest = this.Manifest()?.val() as { format: number, length: number, hashes: number[] } | null
			if( !manifest || manifest.format !== 1 || !Array.isArray( manifest.hashes ) ) throw new Error( 'Снимок версии ещё не загружен.' )
			const text = manifest.hashes.map( ( hash, index ) => {
				const atom = this.Chunks()?.key( String( index ) )
				if( atom ) this.$.$shm_hitalama_map_component_ready.read( atom )
				const chunk = atom?.val() ?? ''
				if( $mol_hash_string( chunk ) !== hash ) throw new Error( 'Часть снимка ещё не загружена или повреждена. Повторите открытие версии.' )
				return chunk
			}).join( '' )
			if( text.length !== manifest.length ) throw new Error( 'Снимок версии загружен не полностью.' )
			return text
		}

		@ $mol_mem
		data() { return $shm_hitalama_components_versions_snapshot.validate( this.text() ) }
	}
}
